module.exports = __webpack_public_path__ + "img/frame (255).219a9530.jpg";